import { ArticleSection } from "@/types/articleEntryData.types";
import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { ARTICLE_SECTION_CODE } from "@FillInTableContainer/constants/fillInTable.constants";
import { getPressIdFromURL } from "@utils/getStateFromURL";

const UNSUITABLE_WITH_REVIEW_REQUIRED_SECTION: ArticleSection[] = [];
export const useCheckReviewRequired = () => {
  const draftArticleId = getPressIdFromURL();
  const { data: articleInfo } = useArticleInfoQuery(Number(draftArticleId));
  const classificationCode = articleInfo?.classificationManual;
  const articleSection = classificationCode
    ? (ARTICLE_SECTION_CODE[classificationCode] as ArticleSection)
    : null;

  return {
    isUnsuitableWithReviewRequired:
      articleSection !== null &&
      UNSUITABLE_WITH_REVIEW_REQUIRED_SECTION.includes(articleSection),
  };
};
